<template>
	<div class="panel-heading">
		<slot />
	</div>
</template>
